import React, { useState, useContext } from 'react';
import { LockContext } from '../context/LockContext';
import '../assets/css/login.css';
import { openConfirm, openAlert } from '../utils/common';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const LockScreen = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { unlock } = useContext(LockContext);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // 로그아웃 처리 핸들러
  const handleLogout = async () => {
    try {
      // AuthContext의 logout 함수 사용
      const success = await logout();
      
      if (success) {
        // 모든 인증 관련 상태 삭제
        sessionStorage.removeItem('locked');
        window.location.href = '/login';
      } else {
        openAlert({ title: '알림', description: '로그아웃에 실패했습니다.' });
      }
    } catch (err) {
      console.error('로그아웃 오류:', err);
      // 오류 발생해도 로그인 화면으로 이동
      window.location.href = '/login';
    }
  };

  // 잠금 해제 핸들러
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    const result = await unlock(password);
    setLoading(false);
    
    if (result.success) {
      // 성공적으로 잠금 해제됨
      return;
    }
    
    // 세션 만료 또는 강제 로그아웃 경우
    if (result.error === 'session_expired' || result.error === 'forced_logout') {
      openConfirm({
        title: '세션이 만료되었습니다.',
        description: '로그인 화면으로 이동하시겠습니까?',
        positive_method: handleLogout,
        positive_btn: '네'
      });
      return;
    }
    
    // 기본 오류 처리 (비밀번호 불일치 등)
    setError(result.message || '비밀번호가 일치하지 않습니다.');
    setPassword('');
  };

  return (
    <div className="wrap">
      <div className="login_wrap">
        <div className="login_box">
          <div className="login_logo">
            <img src="/adm/images/login_logo.png" alt="logo" />
          </div>
          <form className="login_input" onSubmit={handleSubmit}>
            <h2 className="login_title">세션이 잠금되었습니다</h2>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="비밀번호 입력"
              disabled={loading}
              required
            />
            {error && <div className="error_msg">{error}</div>}
            <button type="submit" className="login_btn" disabled={loading}>
              {loading ? '처리중...' : '잠금 해제'}
            </button>
            <div className="login_options">
              <button 
                type="button" 
                className="text_btn" 
                onClick={handleLogout}
                disabled={loading}
              >
                {loading ? '처리중...' : '로그아웃 및 로그인 화면으로 돌아가기'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LockScreen;
